import { Controller } from "react-hook-form";
import Select from "react-select";
import { parseObjByString } from "../../../utils";

const filterSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 42,
        borderRadius: 12,
        borderColor: state.isFocused ? "#191D51" : "#D9D9D9",
        boxShadow: state.isFocused ? "0 0 0 1px #191D51" : "none",
        backgroundColor: "#fff",
        fontSize: 14,
        cursor: "pointer",
        "&:hover": {
            borderColor: "#191D51",
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 12px",
    }),
    placeholder: (base) => ({
        ...base,
        color: "#808080",
        fontSize: 14,
    }),
    singleValue: (base) => ({
        ...base,
        color: "#191D51",
        fontSize: 14,
    }),
    input: (base) => ({
        ...base,
        color: "#191D51",
        fontSize: 14,
    }),
    menu: (base) => ({
        ...base,
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 8px 24px rgba(25, 29, 81, 0.12)",
        zIndex: 20,
    }),
    option: (base, state) => ({
        ...base,
        fontSize: 14,
        backgroundColor: state.isSelected ? "#191D51" : state.isFocused ? "#f1f5f9" : "#fff",
        color: state.isSelected ? "#fff" : "#191D51",
        cursor: "pointer",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#191D51",
        paddingRight: 10,
        "&:hover": {
            color: "#191D51",
        },
    }),
    clearIndicator: (base) => ({
        ...base,
        color: "#808080",
        paddingRight: 4,
        "&:hover": {
            color: "#191D51",
        },
    }),
};

const FilterSelectInput = ({
    name,
    label,
    placeholder = "Select…",
    options,
    control,
    errors,
    onChangeSelect = null,
    isSearchable = false,
    isClearable = false,
}) => {
    const fieldError = errors?.[name] ?? parseObjByString(errors, name)[0];

    return (
        <div className="flex w-full flex-col gap-1.5">
            {label ? (
                <label htmlFor={name} className="text-xs font-semibold uppercase tracking-wide text-nt-grey">
                    {label}
                </label>
            ) : null}
            <Controller
                control={control}
                name={name}
                defaultValue={null}
                render={({ field: { value, onChange } }) => (
                    <Select
                        inputId={name}
                        instanceId={name}
                        isSearchable={isSearchable}
                        isClearable={isClearable}
                        placeholder={placeholder}
                        options={options}
                        value={options.find((option) => option.value === value) ?? null}
                        onChange={(selected) => {
                            onChange(selected ? selected.value : null);
                            onChangeSelect?.(selected);
                        }}
                        styles={filterSelectStyles}
                        classNamePrefix="tutor-filter-select"
                    />
                )}
            />
            {fieldError?.message ? (
                <span className="text-xs text-red">{fieldError.message}</span>
            ) : null}
        </div>
    );
};

export { FilterSelectInput };
